<template>
  <a-card :bordered="false">
    <!--导航区域-->
    <div>
      <a-tabs defaultActiveKey="1" @change="callback">
        <a-tab-pane :tab="$t('用户登录记录')" key="1"></a-tab-pane>
        <a-tab-pane :tab="$t('系统操作日志')" key="2"></a-tab-pane>
        <a-tab-pane :tab="$t('营收模块日志')" key="3"></a-tab-pane>
        <a-tab-pane :tab="$t('工单模块日志')" key="4"></a-tab-pane>
        <a-tab-pane :tab="$t('OA模块日志')" key="5"></a-tab-pane>
      </a-tabs>
    </div>

    <!-- 查询区域 -->
    <div class="table-page-search-wrapper">
      <a-form layout="inline" @keyup.enter.native="searchQuery1">
        <a-row :gutter="24">

          <a-col :md="6" :sm="8">
            <a-form-item :label="$t('账户')" v-if="tabKey == 1">
              <j-input :placeholder="$t('请输入账户模糊查询')" v-model="queryParam.keyWord"></j-input>
            </a-form-item>
            <a-form-item :label="$t('搜索日志')" v-else>
              <a-input :placeholder="$t('请输入搜索关键词')" v-model="queryParam.keyWord"></a-input>
            </a-form-item>
          </a-col>

          <a-col :md="6" :sm="10">
            <a-form-item :label="$t('登录类型')" v-if="tabKey == 1">
              <a-select v-model="queryParam.loginType" :placeholder="$t('请选择登录类型')">
                <a-select-option :value="1">{{ $t('退出') }}</a-select-option>
                <a-select-option :value="0">{{ $t('登录') }}</a-select-option>
              </a-select>
            </a-form-item>
            <a-form-item :label="$t('创建时间')" :labelCol="labelCol" :wrapperCol="wrapperCol" v-else>
              <a-range-picker
                style="width: 210px"
                v-model="queryParam.createTimeRange"
                format="YYYY-MM-DD"
                :placeholder="[$t('开始时间'), $t('结束时间')]"
                @change="onDateChange"
                @ok="onDateOk"
              />
            </a-form-item>
          </a-col>
          <a-col :md="5" :sm="8" v-if="tabKey === '2'">
            <a-form-item :label="$t('操作类型')" style="left: 10px">
              <j-dict-select-tag v-model="queryParam.operateType" :placeholder="$t('请选择操作类型')" dictCode="operate_type"/>
            </a-form-item>
          </a-col>

          <span style="float: left;overflow: hidden;" class="table-page-search-submitButtons">
            <a-col :md="6" :sm="24" >
                <a-button type="primary"  style="left: 10px" @click="searchQuery1" icon="search">{{ $t('查询') }}</a-button>
                <a-button type="primary"  @click="searchReset" icon="reload" style="margin-left: 8px;left: 10px">{{ $t('重置') }}</a-button>
            </a-col>
          </span>

        </a-row>
      </a-form>
    </div>

    <!-- table区域-begin -->
    <a-table
      ref="table"
      size="middle"
      rowKey="id"
      :columns="columns"
      :dataSource="dataSource"
      :pagination="ipagination"
      :loading="loading"
      @change="handleTableChange">

      <div v-show="queryParam.logType!=1" slot="expandedRowRender" slot-scope="record" style="margin: 0">
        <div style="margin-bottom: 5px"><a-badge status="success" style="vertical-align: middle;"/><span style="vertical-align: middle;">{{ $t('请求方法:') }}{{ record.method }}</span></div>
        <div><a-badge status="processing" style="vertical-align: middle;"/><span style="vertical-align: middle;">{{ $t('请求参数:') }}{{ record.requestParam }}</span></div>
      </div>
      <!-- 字符串超长截取省略号显示-->
      <span slot="logContent" slot-scope="text, record">
          <j-ellipsis :value="text" :length="40"/>
        </span>
    </a-table>
    <!-- table区域-end -->
  </a-card>
</template>

<script>
  import { filterObj } from '@/utils/util';
  import { JeecgListMixin } from '@/mixins/JeecgListMixin'
  import JEllipsis from '@/components/jeecg/JEllipsis'
  import { getAction } from '@/api/manage'
  import JInput from '@/components/jeecg/JInput'

  export default {
    name: "LogList",
    mixins:[JeecgListMixin],
    components: {
      JEllipsis,
      JInput
    },
    data () {
      return {
        description: this.$t('这是日志管理页面'),
        // 查询条件
        queryParam: {
          ipInfo:'',
          createTimeRange:[],
          logType:'2',
          keyWord:'',
        },
        tabKey: "1",
        labelCol: {
          xs: { span: 1 },
          sm: { span: 2 },
        },
        wrapperCol: {
          xs: { span: 10 },
          sm: { span: 16 },
        },
        url: {
          userLoginRecord: "/sys/userLoginRecord/list",
          loglist: "/sys/log/list",
          getOpLogDetailInfo:"/jeecg-charge/meter/opLog/getOpLogDetailInfo",
          getOpLogDetailInfoGd:"/jeecg-engineering/engineering/opLog/getOpLogDetailInfo",
          getOpLogDetailInfoOa:"/jeecg-oa/oa/opLog/getOpLogDetailInfo",
          list:'/'
        },
      }
    },
    computed: {
      // 表头（登录记录）
      loginColumns() {
        return [
          {
            title: '#',
            dataIndex: '',
            key:'rowIndex',
            align:"center",
            customRender: (t, r, index) => {
              return parseInt(index)+1;
            }
          },
          {
            title: this.$t('登录账户'),
            align:"left",
            dataIndex: 'loginUser',
            sorter: true
          },
          {
            title: this.$t('登录用户真实名称'),
            align:"left",
            dataIndex: 'loginUserRealname',
            sorter: true
          },
          {
            title: this.$t('登录类型'),
            dataIndex: 'loginType',
            align:"center",
            sorter: true,
            customRender: (t) => {
              if(t == 0){
                return this.$t('登录')
              }else{
                return this.$t('退出')
              }
            }
          },
          {
            title: this.$t('登录客户端操作系统'),
            dataIndex: 'loginOs',
            align:"center",
            sorter: true
          },
          {
            title: this.$t('登录ip'),
            dataIndex: 'loginIp',
            align:"center",
            sorter: true
          },
          {
            title: this.$t('登录城市'),
            dataIndex: 'loginCity',
            align:"center",
            sorter: true
          },
          {
            title: this.$t('登录浏览器'),
            dataIndex: 'loginBrowser',
            align:"center",
          },
          {
            title: this.$t('创建时间'),
            dataIndex: 'createTime',
            align:"center",
            sorter: true
          }
        ]
      },
      // 表头（操作日志）
      operateColumns() {
        return [
          {
            title: '#',
            dataIndex: '',
            key:'rowIndex',
            align:"center",
            customRender: (t, r, index) => {
              return parseInt(index)+1;
            }
          },
          {
            title: this.$t('日志内容'),
            align:"left",
            dataIndex: 'logContent',
            scopedSlots: { customRender: 'logContent' },
            sorter: true
          },
          {
            title: this.$t('操作人ID'),
            dataIndex: 'userid',
            align:"center",
            sorter: true
          },
          {
            title: this.$t('操作人名称'),
            dataIndex: 'username',
            align:"center",
            sorter: true
          },
          {
            title: 'IP',
            dataIndex: 'ip',
            align:"center",
            sorter: true
          },
          {
            title: this.$t('耗时(毫秒)'),
            dataIndex: 'costTime',
            align:"center",
            sorter: true
          },
          {
            title: this.$t('日志类型'),
            dataIndex: 'logType_dictText',
            customRender: (t) => (t ? this.$t(t) : ''),
            /*customRender:function (text) {
              if(text==1){
                return "登录日志";
              }else if(text==2){
                return "操作日志";
              }else{
                return text;
              }
            },*/
            align:"center",
          },
          {
            title: this.$t('创建时间'),
            dataIndex: 'createTime',
            align:"center",
            sorter: true
          },
          {
            title: this.$t('操作类型'),
            dataIndex: 'operateType_dictText',
            customRender: (t) => (t ? this.$t(t) : ''),
            align:"center",
          },
        ]
      },
      columns() {
        return this.tabKey == '1' ? this.loginColumns : this.operateColumns
      }
    },
    mounted(){
      this.dataSource = [];
      this.queryParam.logType = 1;
      this.getuserLoginRecord(1,10);
    },
    methods: {
      handleTableChange(pagination, filters, sorter) {
        //分页、排序、筛选变化时触发
        //TODO 筛选
        if (Object.keys(sorter).length > 0) {
          this.isorter.column = sorter.field;
          this.isorter.order = "ascend" == sorter.order ? "asc" : "desc"
        }
        this.ipagination = pagination;
        var that = this;
        var logType = that.queryParam.logType;
        // that.queryParam = {}; //清空查询区域参数
        that.queryParam.logType = logType;
        if(logType == 1){
          this.getuserLoginRecord(this.ipagination.current,this.ipagination.pageSize,this.queryParam.keyWord,this.queryParam.loginType);
        }else if(logType == 2){
          that.loglist(this.ipagination.current,this.ipagination.pageSize,this.queryParam.keyWord,this.queryParam.operateType,this.queryParam.createTime_begin,this.queryParam.createTime_end);
        }else if(logType == 3){
          this.getOpLogDetailInfo(this.ipagination.current,this.ipagination.pageSize,this.queryParam.keyWord,this.queryParam.createTime_begin,this.queryParam.createTime_end);
        }else if(logType == 4){
          this.getOpLogDetailInfoGd(this.ipagination.current,this.ipagination.pageSize,this.queryParam.keyWord,this.queryParam.createTime_begin,this.queryParam.createTime_end);
        }else if(logType == 5){
          this.getOpLogDetailInfoOa(this.ipagination.current,this.ipagination.pageSize,this.queryParam.keyWord,this.queryParam.createTime_begin,this.queryParam.createTime_end);
        }
      },
      searchQuery1(){
        if(this.tabKey == 1){
          this.getuserLoginRecord(this.ipagination.current,this.ipagination.pageSize,this.queryParam.keyWord,this.queryParam.loginType)
        }else if(this.tabKey == 2){
          this.loglist(this.ipagination.current,this.ipagination.pageSize,this.queryParam.keyWord,this.queryParam.operateType,this.queryParam.createTime_begin,this.queryParam.createTime_end);
        }else if(this.tabKey == 3){
          this.getOpLogDetailInfo(this.ipagination.current,this.ipagination.pageSize,this.queryParam.keyWord,this.queryParam.createTime_begin,this.queryParam.createTime_end);
        }else if(this.tabKey == 4){
          this.getOpLogDetailInfoGd(this.ipagination.current,this.ipagination.pageSize,this.queryParam.keyWord,this.queryParam.createTime_begin,this.queryParam.createTime_end);
        }else if(this.tabKey == 5){
          this.getOpLogDetailInfoOa(this.ipagination.current,this.ipagination.pageSize,this.queryParam.keyWord,this.queryParam.createTime_begin,this.queryParam.createTime_end);
        }
      },
      getQueryParams(){
        var param = Object.assign({}, this.queryParam,this.isorter);
        param.field = this.getQueryField();
        param.pageNo = this.ipagination.current;
        param.pageSize = this.ipagination.pageSize;
        delete param.createTimeRange; // 时间参数不传递后台
        if (this.superQueryParams) {
          param['superQueryParams'] = encodeURI(this.superQueryParams)
          param['superQueryMatchType'] = this.superQueryMatchType
        }
        return filterObj(param);
      },

      // 重置
      searchReset(){
        var that = this;
        var logType = that.queryParam.logType;
        that.queryParam = {}; //清空查询区域参数
        that.queryParam.logType = logType;
        if(logType == 1){
          this.getuserLoginRecord(1,10);
        }else if(logType == 2){
          that.loglist(1,10);
        }else if(logType == 3){
          this.getOpLogDetailInfo(1,10);
        }else if(logType == 4){
          this.getOpLogDetailInfoGd(1,10);
        }else if(logType == 5){
          this.getOpLogDetailInfoOa(1,10);
        }
      },
      // 日志类型
      callback(key){
        this.tabKey = key;
        this.dataSource = [];
        this.queryParam = {};
        if(key == 3){
          this.tabKey = '3';
          this.queryParam.logType=key;
          this.getOpLogDetailInfo(1,10);
        }else if(key == 4){
          this.tabKey = '4';
          this.getOpLogDetailInfoGd(1,10);
        }else if(key == 5){
          this.tabKey = '5';
          this.getOpLogDetailInfoOa(1,10);
        }else{
          // 动态添加操作类型列
          if (key == 2) {
            this.tabKey = '2';
            this.queryParam.logType=key;
            this.loglist(1,10);
          }else if(key == 1){
            this.tabKey = '1';
            this.getuserLoginRecord(1,10);
          }
        }
        this.queryParam.logType=key;
      },
      loglist(pageNo,pageSize,keyWord,operateType,createTime,endTime,){
        getAction(this.url.loglist,{pageNo:pageNo,pageSize:pageSize,keyWord:keyWord,operateType:operateType,createTime_begin:createTime,createTime_end:endTime}).then(res=>{
          if(res.success){
            this.dataSource = res.result.records;
            this.ipagination.total = res.result.total;
            this.ipagination.current = res.result.current;
          }
        })
      },
      // 用户登录记录
      getuserLoginRecord(pageNo,pageSize,keyWord,loginType){
        getAction(this.url.userLoginRecord,{pageNo:pageNo,pageSize:pageSize,loginUser:keyWord,loginType:loginType}).then(res=>{
          if(res.success){
            this.dataSource = res.result.records;
            this.ipagination.total = res.result.total;
            this.ipagination.current = res.result.current;
          }
        })
      },
      // 营收模块日志
      getOpLogDetailInfo(pageNo,pageSize,keyWord,createTime,endTime){
        getAction(this.url.getOpLogDetailInfo,{pageNo:pageNo,pageSize:pageSize,keyWord:keyWord,createTime_begin:createTime,createTime_end:endTime}).then(res=>{
          if(res.success){
            this.dataSource = res.result.records;
            this.ipagination.total = res.result.total;
            this.ipagination.current = res.result.current;
          }
        })
      },
      // 工单模块日志
      getOpLogDetailInfoGd(pageNo,pageSize,keyWord,createTime,endTime){
        getAction(this.url.getOpLogDetailInfoGd,{pageNo:pageNo,pageSize:pageSize,keyWord:keyWord,createTime_begin:createTime,createTime_end:endTime}).then(res=>{
          if(res.success){
            this.dataSource = res.result.records;
            this.ipagination.total = res.result.total;
            this.ipagination.current = res.result.current;
          }
        })
      },
      // oa模块日志
      getOpLogDetailInfoOa(pageNo,pageSize,keyWord,createTime,endTime){
        getAction(this.url.getOpLogDetailInfoOa,{pageNo:pageNo,pageSize:pageSize,keyWord:keyWord,createTime_begin:createTime,createTime_end:endTime}).then(res=>{
          if(res.success){
            this.dataSource = res.result.records;
            this.ipagination.total = res.result.total;
            this.ipagination.current = res.result.current;
          }
        })
      },
      onDateChange: function (value, dateString) {
        console.log(dateString[0],dateString[1]);
        this.queryParam.createTime_begin=dateString[0];
        this.queryParam.createTime_end=dateString[1];
      },
      onDateOk(value) {
        console.log(value);
      },
    }
  }
</script>
<style scoped>
  @import '~@assets/less/common.less'
</style>